module.exports = __webpack_public_path__ + "img/fritz-pantry-portrait-662w.b53b3f7a.jpg";